const STOP_WORDS = new Set([
    'a', 'an', 'the', 'is', 'are', 'was', 'were', 'and', 'or',
    'but', 'if', 'then', 'as', 'at', 'by', 'for', 'with', 'about',
    'of', 'on', 'in', 'to', 'from', 'into', 'up', 'down', 'out', 'over',
    'under', 'through', 'above', 'below', 'can', 'will', 'my', 'your',
    'he', 'she', 'it', 'we', 'they', 'i', 'you', 'me', 'him', 'her',
    'us', 'them', 'this', 'that', 'these', 'those'
]);

const MAX_SLUG_LENGTH = 100;

const createSlug = (title = '') => {
    const normalizedTitle = String(title).trim().toLowerCase();
    if (!normalizedTitle) {
        return '';
    }

    const words = normalizedTitle
        .replace(/[^a-z0-9\s-]/g, ' ')
        .split(/\s+/)
        .filter((word) => word && !STOP_WORDS.has(word));

    let slug = '';
    words.forEach((word) => {
        const nextSlug = slug ? `${slug}-${word}` : word;
        if (nextSlug.length <= MAX_SLUG_LENGTH) {
            slug = nextSlug;
        }
    });

    return slug.replace(/^-+|-+$/g, '');
};

export default createSlug;
